var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { Editable, Item, ItemPriceService } from './item-price.service';
import { ItemAddRowDirective } from './item-addrow.directive';
var ItemPriceComponent = /** @class */ (function (_super) {
    __extends(ItemPriceComponent, _super);
    function ItemPriceComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.items = [];
        _this.editables = [];
        _this.readonly = false;
        _this.checkFlg = true;
        _this.seq = 1;
        return _this;
    }
    ItemPriceComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.setCompRec();
        this.subsc = this.service.observable.subscribe(function (flg) {
            if (flg) {
                _this.addError();
            }
        });
        this.now = new Date();
        this.now.setSeconds(0, 0);
    };
    ItemPriceComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.cols.length > 0) {
            this.col = this.cols[0];
        }
        this.checkFlg = true;
    };
    ItemPriceComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ItemPriceComponent.prototype.onSubscribe = function (data) {
        this.items = [];
        if (typeof data[this.col.key] !== 'undefined' && data[this.col.key] instanceof Array) {
            this.items = data[this.col.key];
        }
        if (this.checkFlg) {
            this.editables = [];
            var now = new Date();
            now.setSeconds(0);
            now.setMilliseconds(0);
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                var s_date = new Date(item.start_date);
                var editable = new Editable();
                if (s_date.getTime() <= now.getTime()) {
                    editable.delete = false;
                    editable.start_date = false;
                    editable.price = false;
                }
                this.editables.push(editable);
                if (typeof item.id !== 'undefined') {
                    item.$type = "put" /* Put */;
                }
            }
            this.checkFlg = false;
        }
        if (this.col.required && this.items.length === 0) {
            this.items.push(new Item());
            this.editables.push(new Editable());
        }
        this.seq = 1;
        for (var _b = 0, _c = this.items; _b < _c.length; _b++) {
            var item = _c[_b];
            item.$seq = this.seq++;
        }
        this.setCompRec();
    };
    ItemPriceComponent.prototype.trackByItem = function (index, item) {
        return item.$seq;
    };
    ItemPriceComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    ItemPriceComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    ItemPriceComponent.prototype.onAdd = function () {
        this.items.push(Object.assign(new Item(), { $seq: this.seq++ }));
        this.editables.push(new Editable());
        this.addError();
        this.setCompRec();
    };
    ItemPriceComponent.prototype.onDelete = function (index) {
        if (typeof this.items[index].id === 'undefined' || this.items[index].id === null) {
            this.items.splice(index, 1);
            this.editables.splice(index, 1);
        }
        else {
            this.items[index].$type = "delete" /* Delete */;
        }
        this.addError();
        this.setCompRec();
    };
    ItemPriceComponent.prototype.onChange = function (e, key, index) {
        this.items[index][key] = e.val;
        this.setCompRec();
    };
    ItemPriceComponent.prototype.setCompRec = function () {
        var items = {};
        items[this.col.key] = this.items;
        this.action.setCompRec(this.componentName, items);
    };
    ItemPriceComponent.prototype.addError = function () {
        if (this.col.required) {
            var items = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                if (item.$type !== "delete" /* Delete */) {
                    items.push(item);
                }
            }
            var errFlg = (items.length === 0 ? true : false);
            this.dir.addRequiredError(errFlg, this.msgSnapshot['ColumnComponent.error.required']);
        }
    };
    ItemPriceComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
    };
    ItemPriceComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'item-price',
                    template: "<form id=\"{{ componentName }}\" *ngIf=\"col\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\">\n          <column-formtitle [key]=\"'list'\" [col]=\"col\" [msg]=\"(msg | async)\"></column-formtitle>\n        </dt>\n        <dd class=\"form_dd\" itemAddRowDir></dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"tableWrapper\">\n    <table class=\"tableWrapper_table\">\n      <thead>\n      <tr data-href=\"#\">\n        <th [hidden]=\"readonly\" scope=\"col\"></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemPriceComponent.label.startDate'] }}</a></th>\n        <th scope=\"col\"><a class=\"-fixed\">{{ (msg | async)['ItemPriceComponent.label.price'] }}</a></th>\n      </tr>\n      </thead>\n      <tbody>\n      <ng-template ngFor let-item [ngForOf]=\"items\" let-index=\"index\" [ngForTrackBy]=\"trackByItem\">\n        <tr *ngIf=\"item.$type !== 'delete'\" data-href=\"#\" class=\"tr_cursorDefault\">\n          <td [hidden]=\"readonly\" class=\"tableWrapper_iconTd\">\n            <a *ngIf=\"editables[index].delete && !(col.required && index === 0)\" href=\"javascript:void(0);\" (click)=\"onDelete(index)\"><img src=\"img/icon_delete.svg\" alt=\"\" width=\"18\"></a>\n          </td>\n          <td>\n            <dl *ngIf=\"!(col.required && index === 0)\" class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li\">\n                    <column-datetime *ngIf=\"!readonly && editables[index].start_date\" [key]=\"'list'\" [col]=\"{\n\t\t\t\t\t\t\t\t\t\t\tkey: componentName + '.start_date-' + item.$seq,\n\t\t\t\t\t\t\t\t\t\t\tcontrolType: 'datetime',\n\t\t\t\t\t\t\t\t\t\t\trequired: true,\n\t\t\t\t\t\t\t\t\t\t\tparams: {options: {minDate: now}}\n\t\t\t\t\t\t\t\t\t\t}\" [val]=\"item['start_date']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'start_date', index)\"></column-datetime>\n                    <column-formreadonly *ngIf=\"readonly || !editables[index].start_date\" [col]=\"{controlType: 'datetime'}\" [val]=\"item['start_date']\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n          <td>\n            <dl class=\"form\">\n              <dt></dt>\n              <dd class=\"form_dd\">\n                <ul>\n                  <li class=\"form_li\">\n                    <column-number *ngIf=\"!readonly && editables[index].price\" [key]=\"'list'\" [col]=\"{\n\t\t\t\t\t\t\t\t\t\t\tkey: componentName + '.price-' + item.$seq,\n\t\t\t\t\t\t\t\t\t\t\tcontrolType: 'number',\n\t\t\t\t\t\t\t\t\t\t\trequired: true,\n\t\t\t\t\t\t\t\t\t\t\tparams: {options: {min: 0}}\n\t\t\t\t\t\t\t\t\t\t}\" [val]=\"item['price']\" [msg]=\"(msg | async)\" (changeVal)=\"onChange($event, 'price', index)\"></column-number>\n                    <column-formreadonly *ngIf=\"readonly || !editables[index].price\" [col]=\"{controlType: 'number'}\" [val]=\"item['price']\" [msg]=\"(msg | async)\"></column-formreadonly>\n                  </li>\n                </ul>\n              </dd>\n            </dl>\n          </td>\n        </tr>\n      </ng-template>\n      </tbody>\n    </table>\n  </div>\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <p *ngIf=\"!readonly\">\n        <button class=\"addBtn\" type=\"button\" (click)=\"onAdd()\"></button>\n      </p>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    ItemPriceComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ItemPriceService }
    ]; };
    ItemPriceComponent.propDecorators = {
        dir: [{ type: ViewChild, args: [ItemAddRowDirective,] }]
    };
    return ItemPriceComponent;
}(ContentBaseComponent));
export { ItemPriceComponent };
//# sourceMappingURL=item-price.component.js.map